import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LandingComponent } from './modules/campaign/landing/landing.component';
import { LayoutComponent } from './modules/page-layout/layout/layout.component';
import { FeedbackComponent } from './modules/support/feedback/feedback.component';
import { EmailReminderComponent } from './modules/shared/email-reminder/email-reminder.component';
import { ClickToPlayComponent } from './modules/campaign/click-to-play/click-to-play.component';
import { FeedbackSuccessComponent } from './modules/support/feedback-success/feedback-success.component';
import { CookieComponent } from './modules/support/cookie/cookie.component';
import { RedirectionGuard } from './core/guards/redirection.guard';
import { LoginComponent } from './modules/campaign/login/login.component';
import { ResetPasswordComponent } from './modules/campaign/reset-password/reset-password.component';
import { HeaderComponent } from './modules/page-layout/header/header.component';
import { AppComponent } from './app.component';
import { RewardsListComponent } from './modules/campaign/rewards-list/rewards-list.component';
import { RegisterComponent } from './modules/campaign/register/register.component';
import { ProfileComponent } from './modules/campaign/profile/profile.component';
import { UploadReceiptComponent } from './modules/campaign/upload-receipt/upload-receipt.component';
import { ScanParticipateComponent } from './modules/campaign/scan-participate/scan-participate.component';
import { SuccessComponent } from './modules/campaign/scan-participate/success/success.component';
import { ReportsComponent } from './modules/campaign/reports/reports.component';
import { StripePayComponent } from './modules/campaign/stripe-pay/stripe-pay.component';
import { StripeSuccessComponent } from './modules/campaign/stripe-success/stripe-success.component';
import { AuthGuard } from './core/guards/auth.guard';
import { ReportsLoginComponent } from './modules/campaign/reports-login/reports-login.component';
import { ReceiptInsightsComponent } from './modules/campaign/receipt-insights/receipt-insights.component';
import { StripeCancelComponent } from './modules/campaign/stripe-cancel/stripe-cancel.component';
import { SwishPayComponent } from './modules/campaign/swish-pay/swish-pay.component';

const campaignRoutes: Routes = [

  //Default - Finnish
  { path: '', component: LandingComponent, },
  { path: 'feedback', component: FeedbackComponent },
  { path: 'reminder', component: EmailReminderComponent },
  { path: 'click-to-play', component: ClickToPlayComponent },
  { path: 'feedback/success', component: FeedbackSuccessComponent },
  { path: 'cookie', component: CookieComponent },
  { path: 'login', component: LoginComponent },
  {path: 'reset-password', component: ResetPasswordComponent},
  {path: 'app', component: AppComponent},
  {path: 'rewards', component: RewardsListComponent},
  { path: 'register', component: RegisterComponent },
  { path: 'upload', component: UploadReceiptComponent },
  { path: 'profile', component: ProfileComponent},
   { path: 'stripe-pay', component: StripePayComponent},
  { path: 'payment-success', component: StripeSuccessComponent},
  { path: 'payment-cancel', component: StripeCancelComponent},
  { path: 'pay', component: SwishPayComponent },
  { path: 'scan-participate', component: ScanParticipateComponent},
  { path: 'scan/success', component: SuccessComponent },
    { path: 'reports', component: ReportsComponent, canActivate:[AuthGuard] },
    { path: 'reports-login', component: ReportsLoginComponent },
    { path: 'receipt-insights', component: ReceiptInsightsComponent, canActivate:[AuthGuard] }
];

const routes: Routes = [
  ...campaignRoutes,
  { path: 'se', children: campaignRoutes },
  { path: 'fi', children: campaignRoutes },
  { path: '**', redirectTo: '' },




  // { path: '', component: LandingComponent, pathMatch: 'full' },
  // { path: 'se', component: LandingSeComponent },
  // { path: 'home/:type', component: HomeComponent },
  // { path: 'play', component: PlayComponent },
  // { path: 'rules', component: RulesComponent },
  // { path: 'feedback', component: FeedbackComponent },
  // { path: 'feedback/success', component: FeedbackSuccessComponent },
  // { path: 'admin', component: AdminComponent },
  // { path: 'upload', component: PlayWithReceiptComponent },
  // { path: '*', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes,
    {
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
      scrollOffset: [0, 100] // [x, y]
    }
  )],
  exports: [RouterModule]
})
export class AppRoutingModule { }
